import cn from 'classnames';
import { FC, ReactElement } from 'react';

import HeaderCatalog from '../../components/HeaderCatalog';
import { HeroBlockCatalog } from '../../components/HeroBlock';
import MainPageFooter from '../../components/MainPageFooter';
import { VacanciesCatalog } from '../../components/VacanciesCatalog';
import { SEO } from '../../utils/constants/seo';
import { useDocumentSeo } from '../../utils/useDocumentSeo';
import classes from './CatalogVacancies.module.scss';

export const CatalogVacancies: FC = (): ReactElement => {
  useDocumentSeo(SEO.catalogVacancies);

  return (
    <div className={cn(classes['catalog-vacancies'])}>
      <HeaderCatalog
        className={classes['catalog-vacancies__header']}
        colored
        isSticked
      />
      <HeroBlockCatalog
        className={classes['catalog-vacancies__hero-block']}
      />
      <VacanciesCatalog
        className={classes['catalog-vacancies__vacancies-catalog']}
      />

      <MainPageFooter />
    </div>
  );
};
